import { Tag, type TableColumnsType } from 'antd';
import { CatalogueRowActions } from '../../../../../shared/components/CatalogueRowActions';
import type { JobType } from '../../../reference-data.api';

interface BuildJobTypeColumnsArgs {
  onEdit: (row: JobType) => void;
  onDeactivate: (row: JobType) => Promise<void>;
  onReactivate: (row: JobType) => Promise<void>;
}

const FAMILY_LABEL: Record<JobType['family'], string> = { container: 'Container', loose: 'Loose' };

export function buildJobTypeColumns({ onEdit, onDeactivate, onReactivate }: BuildJobTypeColumnsArgs): TableColumnsType<JobType> {
  return [
    { title: 'Code', dataIndex: 'code', key: 'code', render: (code: string) => <span className="font-mono text-xs">{code}</span> },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Family', dataIndex: 'family', key: 'family', render: (family: JobType['family']) => FAMILY_LABEL[family] },
    {
      title: 'Required documents',
      dataIndex: 'requiredDocuments',
      key: 'requiredDocuments',
      render: (requiredDocuments: JobType['requiredDocuments']) =>
        requiredDocuments.length > 0 ? requiredDocuments.map((d) => d.name).join(', ') : <span className="text-muted">None</span>,
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, row) => <CatalogueRowActions row={row} onEdit={onEdit} onDeactivate={onDeactivate} onReactivate={onReactivate} />,
    },
  ];
}
